import {Stack} from 'src/design/atoms/Stack';
import React from 'react';

import 'src/redux/queries/formsOfflineRegistration';
import 'src/redux/queries/offlineTestRegistration';
import {BackBar} from 'src/app/layout/BackBar';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';
import {PageHeader} from 'src/design/organisms/PageHeader';
import {SectionCard} from 'src/design/atoms/SectionCard';
import {SidebarLinkTestArea} from 'src/app/layout/Sidebar/SidebarLinksConfig';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import {ConnectivityCard} from './components/ConnectivityCard';
import {FileCaptureCard} from './components/FileCaptureCard';
import {OutboxTable} from './components/OutboxTable';
import {QueueWritesCard} from './components/QueueWritesCard';
import {SessionCard} from './components/SessionCard';
import {SyncCard} from './components/SyncCard';
import {useOfflineTestData} from './hooks/useOfflineTestData';

export const OfflineTestPage: React.FC = () => {
  const {activeSession, outboxItems, snapshots} = useOfflineTestData();

  return (
    <ContentWrapper>
      <Stack gap="lg">
        <BackBar
          fallbackTo={PathUtility.AdminTestArea()}
          fallbackLabel="Back to Test Area"
          breadcrumbs={[
            {label: 'System', to: PathUtility.AdminSystem()},
            {label: 'Test Area', to: PathUtility.AdminTestArea()},
            {label: 'Offline Test'},
          ]}
        />
        <PageHeader>
          <PageHeader.Title
            icon={SidebarLinkTestArea.icon}
            subtitle="Exercise the offline session core — connectivity, session lifecycle, outbox, and sync — the validation vehicle until real modules integrate.">
            Offline Test
          </PageHeader.Title>
        </PageHeader>
        <ConnectivityCard />
        <SessionCard
          activeSession={activeSession}
          outboxItems={outboxItems}
          snapshots={snapshots}
        />
        <QueueWritesCard activeSession={activeSession} />
        <FileCaptureCard activeSession={activeSession} />
        <SectionCard title="Outbox">
          <OutboxTable items={outboxItems} />
        </SectionCard>
        <SyncCard activeSession={activeSession} outboxItems={outboxItems} />
      </Stack>
    </ContentWrapper>
  );
};

routeRegistry.registerPageRoute({
  backNavigation: 'page',
  path: PathUtility.AdminOfflineTest(),
  element: <OfflineTestPage />,
  isPrivate: true,
  supportsOffline: true,
  requireSuperAdmin: true,
});
